import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'

import { useParams } from 'react-router-dom'
import SubProjectListWidget from '../../widgets/subProject/SubProjectListWidget'

export default function SubProjectList() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const { projectId } = useParams()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      console.log('projectId : ', projectId)
      // const request = {
      //   lawType: null,
      //   projectCode: null,
      //   docNumberOfPurchase: null,
      //   contractNumberRef: null,
      //   pageNumber: 1,
      //   pageSize: 5,
      // }

      // const _schema = await getLegalManagement(request)
      // console.log('getLegalManagement ', _schema)

      setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.model.header} subHeader={''} isNotCallApi />

        <SubProjectListWidget schema={schema.model} />
        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 5,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ข้อมูลโครงการย่อย',
    subHeader: '',
    disabled: false,
    projectInfo: {
      projectId: 'LKJOOK-LKOJOJKHGH-OIKOID-OIII',
      projectCode: '64-00867',
      projectName: 'โครงการทดสอบ',
      duration: '1/ม.ค./2564 - 31/ม.ค./2565', // ระยะเวลาดำเนินงาน
      countOfSubProject: '11', // มีโครงการย่อย
      isPurchaseOfDurableGoods: 'มี', //จัดซื้อครุภัณฑ์ มี,ไม่ระบุ
      contractNo: '64-00-0596',
      coordinator: 'ชลการ นักประสาน (สำนัก 6)',
      responsibler: 'สมชาย เก่งกาจ', // ผู้รับผิดชอบโครงการ
      projectStatus: 'ดำเนินการ',
    },
    subProjectList: [
      {
        id: '1',
        code: '66-00145-01',
        contractNo: '66-00145-00001',
        name: 'โครงการย่อยที่ 1',
        status: 'ดำเนินการ',
        budget: 20000,
        startDate: '02/เม.ย./25646',
        endDate: '30/ตุ.ค./2566',
        grantee: 'นาย เอ',
      },
      {
        id: '2',
        code: '66-00145-02',
        contractNo: '66-00145-00002',
        name: 'โครงการย่อยที่ 2',
        status: 'ดำเนินการ',
        budget: 20000,
        startDate: '02/เม.ย./25646',
        endDate: '30/ตุ.ค./2566',
        grantee: 'นาย เอ',
      },
      {
        id: '3',
        code: '66-00145-03',
        contractNo: '66-00145-00003',
        name: 'โครงการย่อยที่ 3',
        status: 'ดำเนินการ',
        budget: 78000,
        startDate: '02/เม.ย./25646',
        endDate: '30/ตุ.ค./2566',
        grantee: 'นาย เอ',
      },
      {
        id: '4',
        code: '66-00145-04',
        contractNo: '66-00145-00004',
        name: 'โครงการย่อยที่ 4',
        status: 'ดำเนินการ',
        budget: 25000,
        startDate: '02/เม.ย./25646',
        endDate: '30/ตุ.ค./2566',
        grantee: 'นาย เอ',
      },
      {
        id: '5',
        code: '66-00145-05',
        contractNo: '66-00145-00005',
        name: 'โครงการย่อยที่ 5',
        status: 'ดำเนินการ',
        budget: 14000,
        startDate: '02/เม.ย./25646',
        endDate: '30/ตุ.ค./2566',
        grantee: 'นาย เอ',
      },
      {
        id: '6',
        code: '66-00145-06',
        contractNo: '66-00145-00006',
        name: 'โครงการย่อยที่ 6',
        status: 'ดำเนินการ',
        budget: 14000,
        startDate: '02/เม.ย./25646',
        endDate: '30/ตุ.ค./2566',
        grantee: 'นาย เอ',
      },
      {
        id: '7',
        code: '66-00145-07',
        contractNo: '66-00145-00007',
        name: 'โครงการย่อยที่ 7',
        status: 'ดำเนินการ',
        budget: 14000,
        startDate: '02/เม.ย./25646',
        endDate: '30/ตุ.ค./2566',
        grantee: 'นาย เอ',
      },
    ],
  },
}
